import React from "react";
import { motion } from "framer-motion";
import { FaDownload } from "react-icons/fa";
import Heading from "../../shared/Heading";
import Layout from "../../shared/Layout";
import ScrollToTop from "../../shared/utils/ScrollToTop";
import { documents } from "./documents";

export default function PublicResources() {
  return (
    <>
      <ScrollToTop />
      <Layout>
        <motion.div
          initial={{ x: "100%" }}
          animate={{ x: "0%" }}
          transition={{ duration: 0.6, ease: "easeOut" }}
          className="pt-20"
        >
          <Heading firstHeading="Resources" secondHeading="For Innovators" />

          <div className="container mx-auto px-4 py-10">
            <p className="max-w-3xl mx-auto text-center pb-10">
              Sample templates of the documents you will need along the way.
              Click a document to download it, then edit it for your own use.
            </p>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              {documents.map((document) => {
                const Icon = document.icon;
                return (
                  <a
                    key={document.file}
                    href={document.file}
                    download
                    className="flex flex-col items-center text-center gap-4 p-8 rounded-md shadow-md bg-white hover:scale-105 transition-transform duration-300"
                  >
                    <Icon className="w-12 h-12 fill-secondary" />
                    <h3 className="text-xl font-bold">{document.name}</h3>
                    <p className="text-sm">{document.description}</p>
                    <div className="flex items-center gap-2 font-bold text-secondary">
                      <FaDownload />
                      <span>Download</span>
                    </div>
                  </a>
                );
              })}
            </div>
          </div>
        </motion.div>
      </Layout>
    </>
  );
}
